import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Remarks extends React.Component {

  state = {
    openRemarks: false,
    fullWidth: true,
    maxWidth: 'sm',
  }

  render() {
    let remarks = this.props.remarks;
    try {
      if (remarks.length > 5) {
        remarks = remarks.substr(0, 5);
        remarks = remarks+'...';
      }
      if (remarks.length == 0) {
        remarks = 'No Remarks';
      }
    } catch (e) {
      remarks = 'No Remarks';
    }
    return (
      <div>
        <b onClick={ () => { this.setState({ openRemarks: true }) }} style={{color: '#3A8DC1'}}>
        {remarks}
        </b>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.openRemarks}
            onClose={ () => { this.setState({ openRemarks: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Remark`s</DialogTitle>
            <DialogContent>
              {this.props.remarks}
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ openRemarks: false }) }}>Okay</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Remarks;
